let filters = {
    query_answer: {name: 'query_answer', 'nickname': 'Query Text', type: 'text', options: {},selections: {}, size: 2},
    published_date: {name: 'published_date', 'nickname': 'Published Date', type: 'date_range', options: {},selections: {}, size: 2},
    published_month: {name: 'published_month', 'nickname': 'Published Month', type: 'multi', options: {},selections: {}, size: 2},
    company_name: {name: 'company_name', 'nickname': 'Company', type: 'multi', options: {},selections: {}, size: 2},
    published_by: {name: 'published_by', 'nickname': 'Published By', type: 'multi', options: {},selections: {}, size: 2},
    topic_value: {name: 'topic_value', 'nickname': 'Topic', type: 'multi', options: {},selections: {}, size: 2}
}

module.exports = filters